<template>
    <Loading>
        <div class="p-4">
            <Row class="w-50" rounded />
            <Row class="input-row mb-4" rounded />

            <Row class="w-50" rounded />
            <div class="d-flex align-items-center">
                <Row class="input-row w-50 mr-2" rounded />
                <Row class="input-row flex-grow" rounded />
            </div>
        </div>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Avatar from '~/components/skeletons/base/Avatar';
import Row from '~/components/skeletons/base/Row';

export default {
    name: 'ContactDetailsSkeleton',
    components: { Loading, Avatar, Row },
};
</script>

<style scoped>
.input-row {
    height: 38px;
}
</style>
